import React, { useEffect } from 'react'
import {
  PopupContainer,
  PopupHeading,
  PopupDescription,
  PopupRewardPoints,
  PopupTips,
  PopupFeedBack,
} from './styles'
import ChevronLeft from '../../../components/Images/ChevronLeft'
import Speaker from './Images/megaphone.svg'
import Academy from './Images/academy.svg'
import ThumbsUp from './Images/thumbsUp.svg'
import Incentive from './Images/incentive.svg'
import { handleEventLog } from '../../../lib/utils'

function LearnMorePopup({ setOpenLearnMorePopup, authorName, bookId }) {
  useEffect(() => {
    handleEventLog('incentive upgrade annocement', 'page_load', {
      entity_id: bookId,
      entity_type: 'book',
    })
    if('IntersectionObserver' in window){
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {   
            if (entry.isIntersecting) {
              handleEventLog('post_publish', 'impressions', {
                  module_name: entry.target.id,
                  entity_id: bookId,
                  entity_type: 'book',
              })
            }
          })
        }, {
          delay: 100,
          trackVisibility: true,
          threshold: 0.9,
        }
      )

      const element = document.getElementById('daily_update_bonus_Learn_more')
      observer.observe(element)

      return () => observer.disconnect()
    }
  }, [])

  return (
    <PopupContainer id='daily_update_bonus_Learn_more'>
      <ChevronLeft
        fillOpacity="1"
        style={{
          background: '#ffffffa8',
          borderRadius: '4px',
          position: 'fixed',
          top: `1rem`,
          left: `1rem`,
          cursor: 'pointer',
        }}
        height={'35px'}
        width={'35px'}
        onClick={() => setOpenLearnMorePopup(false)}
      />
      <img src={Incentive} alt="" />
      <PopupHeading>You can now earn 3x times more!</PopupHeading>
      <PopupDescription>
        Congrats, <span>{authorName}</span> your Novel has amazing retention,
        Readers keep coming every day to check for updates on your novel and as
        a token of our appreciation, we are excited to announce a limited-time
        incentive just for you. <br />
        <span>
          Your incentive is now updated from 10 paise/word to 20 paise & streak
          incentive to 30 paise/word.
        </span>
      </PopupDescription>
      <PopupRewardPoints>
        <img src={Speaker} alt="" />
        Publish at least <span>2000</span> words daily for a month
        <br />
        <ul>
          <li>
            You will now earn <span>₹12,000</span> instead of ₹6,000 <br />
          </li>
          <li>
            You will now earn <span>₹18,000</span> (if on streak)
          </li>
        </ul>
      </PopupRewardPoints>
      <PopupTips>
        <p>
          <img src={Academy} alt="" /> Tips
        </p>
        <ol>
          <li>
            {' '}
            Make your readers come back every day for more & more content (
            retention )
          </li>
          <li>
            To improve retention it is very important to publish at least 2,000
            or more words daily with great hooks for the next chapter.
          </li>
          <li>
            If we notice retention improved in your novel , we might consider
            making this limited-time incentive to permanent.
          </li>
        </ol>
      </PopupTips>
      <PopupFeedBack>
        <img src={ThumbsUp} alt="" />{' '}
        <p>
          Please share your feedback or doubts{' '}
          <a 
            href="https://docs.google.com/forms/d/1CzFksrcUVXZOb5Neg3oaZqbwJcZZRSBO7gpi3z8iSMs/viewform?edit_requested=true#settings"
            target="_blank"
          >
            here
          </a>
        </p>
      </PopupFeedBack>
    </PopupContainer>
  )
}

export default LearnMorePopup
